export default "__VITE_ASSET__J6WRcEh8__"